import { DeepReadonly, IRisk } from 'types';
import { deepFreeze } from '../utils/deepFreeze';

export const defaultRisks: DeepReadonly<IRisk> = deepFreeze({
  personalInfoRisk: {
    namesAndAliases: [],
    birthAndNationality: [],
    criminalConvictions: [],
    englishTest: [],
    passportDetails: []
  },
  historyRisk: {
    priorStudyAndTravel: [],
    priorStudyAndRefusals: [],
    travellersAndDependants: []
  },
  fundingRisk: {
    organisationSponsorship: [],
    scholarshipSponsorship: [],
    educationSponsorship: [],
    familySponsorship: [],
    other: []
  },
  preCasInterviewRisk: {
    step1: [],
    step2: [],
    step3: [],
    step4: []
  },
  docsRisk: {
    parentalConsent: [],
    birthCertificate: []
  },
  financeDocsRisk: {
    organisationSponsorship: [],
    scholarshipSponsorship: [],
    educationSponsorship: [],
    familySponsorship: [],
    birthCertificate: [],
    evidenceOfIncome: []
  },
  countryMultiplier: 0,
  clearedRisks: {
    personalInfoRisk: {
      namesAndAliases: [],
      birthAndNationality: [],
      criminalConvictions: [],
      englishTest: [],
      passportDetails: []
    },
    historyRisk: {
      priorStudyAndTravel: [],
      priorStudyAndRefusals: [],
      travellersAndDependants: []
    },
    fundingRisk: {
      organisationSponsorship: [],
      scholarshipSponsorship: [],
      educationSponsorship: [],
      familySponsorship: [],
      other: []
    },
    preCasInterviewRisk: {
      step1: [],
      step2: [],
      step3: [],
      step4: []
    },
    docsRisk: {
      parentalConsent: [],
      birthCertificate: []
    },
    financeDocsRisk: {
      organisationSponsorship: [],
      scholarshipSponsorship: [],
      educationSponsorship: [],
      familySponsorship: [],
      birthCertificate: [],
      evidenceOfIncome: []
    }
  }
});
